import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { WidgetDetailsResponse } from 'src/app/services/widgets.service';

@Injectable()
export class WidgetsWidgetService {
  constructor(private http: HttpClient) {}

  private get baseUrl(): string {
    return `${environment.apiBaseUrl}/api`;
  }

  private resolveStoreId(): string {
    let storeId = localStorage.getItem('ss_SelectedStoreId');
    if (storeId) {
      return storeId;
    }

    const storeInfo = localStorage.getItem('store');
    if (storeInfo) {
      try {
        const parsed = JSON.parse(storeInfo);
        if (parsed?.SelectedStoreId) {
          return String(parsed.SelectedStoreId);
        }
      } catch {
        // ignore parse error
      }
    }

    return '163';
  }

  private buildHeaders(extra: Record<string, string> = {}): HttpHeaders {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...extra
    };

    const token = localStorage.getItem('access_token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return new HttpHeaders(headers);
  }

  detailWidget(uid: string | undefined = undefined): Observable<WidgetDetailsResponse> {
    const url = `${this.baseUrl}/admin/store/${this.resolveStoreId()}/videoshopping/widget/detail/${uid}`;
    return this.http.get<WidgetDetailsResponse>(url, { headers: this.buildHeaders() }).pipe(
      catchError(err => throwError(() => err))
    );
  }

  detailWidgetPublic(uid: string | undefined = undefined): Observable<WidgetDetailsResponse> {
    const url = `${this.baseUrl}/admin/store/${this.resolveStoreId()}/videoshopping/widget/detail/${uid}/public`;
    return this.http.get<WidgetDetailsResponse>(url, { headers: this.buildHeaders() }).pipe(
      catchError(err => throwError(() => err))
    );
  }
}
